
export const formatLimitString=(texto, size)=>
{
    if (texto===null) return '';
    if (texto.length>size)
    {
        return texto.substring(0, size) + '...'
    } else 
    {
        return texto;
    }
        
}

export const loadingButton=(buttonCode, classIcon)=>
{
    var elementButton = document.getElementById("btn_" + buttonCode);
    var elementIcon = document.getElementById("i_" + buttonCode);

    elementButton.setAttribute("disabled","disabled");

    elementIcon.classList.remove(classIcon);
    elementIcon.classList.add("fa-refresh");
    elementIcon.classList.add("fa-spin");
}

export const loadingButtonEnd=(buttonCode, classIcon)=>
{
    var elementButton = document.getElementById("btn_" + buttonCode);
    var elementIcon = document.getElementById("i_" + buttonCode);

    elementButton.removeAttribute("disabled");

    elementIcon.classList.remove("fa-refresh");
    elementIcon.classList.remove("fa-spin");
    elementIcon.classList.add(classIcon);
}

export const loadingPrincipal=(show)=>
{
    const ele = document.getElementById('ipl-progress-indicator');
    const body = document.getElementById('root');
    if (show)
    {
        body.setAttribute("style","display:none");
        ele.classList.remove('available');
    }
    else 
    {
        body.removeAttribute("style");
        ele.classList.add('available');
    }
}

/// Functions for JSON array
export const deleteItemArray=(array, name, key)=>{
    var list = JSON.parse(JSON.stringify(array));
    return list.filter(item=> { return item[name]!=key; });
}

export const findItemArray=(array, name, key)=>{
    var list = JSON.parse(JSON.stringify(array));
    return list.filter(item=> { return item[name]===key; });
}

export const addItemArray=(array, item)=>{
    var list = JSON.parse(JSON.stringify(array));
    var element = JSON.parse(JSON.stringify(item));
    list.push(element);
    return list;
}

export const updateItemArray=(array, name, key, item)=>{
    var list = deleteItemArray(array, name, key);
    var returnList = addItemArray(list, item);
    return returnList;
}

export const updateValueInItemArray=(array, key, value, field, change)=>
{
    var list = JSON.parse(JSON.stringify(array));
    var item = list.find(x => x[key] == value);
    if (item) item[field] = change;
    return list;
}

export const updateValueInJson =(object, key, value)=>
{
    var obj = JSON.parse(JSON.stringify(object));
    if (obj) obj[key] = value;
    return obj;
}

/// ------------------------------

/// General functions

export const formatDate=(date, format) => {
    var newDate = new Date(date);
}



export const fileToBase64 = (filename, filepath) => {
    return new Promise(resolve => {
      var file = new File([filename], filepath);
      var reader = new FileReader();
      // Read file content on file loaded event
      reader.onload = function(event) {
        resolve(event.target.result);
      };
      
      // Convert data to base64 
      reader.readAsDataURL(file);
    });
  };

  export const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});